module.exports = "/**\n * Function to create an optimized svg url\n */\n/**\n * Replace `$search` with `$replace` in `$string`\n * @author Hugo Giraudel\n * @param {String} $string - Initial string\n * @param {String} $search - Substring to replace\n * @param {String} $replace ('') - New value\n * @return {String} - Updated string\n */\nh5 {\n  color: #3fc5f7; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/liability/steps/licenses-and-affiliations/licenses-and-affiliations-screen.component.scss
// module id = 1432
// module chunks = 0